import ConfigNode from 'Model/ConfigNode'
import { branch } from 'Model/constants'

class TypeColors extends ConfigNode
  @className = 'TypeColors'

  constructor: ->
    super('typeColors')

  map: ->
    @get('value')

  update: (map, params = {}) ->
    @set('value', map, { dataType: 'json' })
    @save(params)

  reset: (params = {}) ->
    @update({}, params)

  @load: ->
    super('typeColors', @)

export default TypeColors
